// extracted by mini-css-extract-plugin
export default {"background":"Banner_background__SPMFH"};